import dayjs from "@/lib/helpers/dayjs";

const MONTH_NAMES = [
  "",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

type ScheduleTimeSlot = unknown;

type DaySelectableComponent = {
  getAvailableSchedules: (
    dateString: string,
    providerId: string,
  ) => Promise<{ time_slots: ScheduleTimeSlot[] }>;
  setState: (state: Record<string, unknown>) => void;
  state: {
    earliestDateAllowed: string;
    providerId: string;
  };
};

// Shared across schedule widgets (patient self-schedule + provider on-behalf-of-schedule).
// `component` is duck-typed rather than a specific class so both usages stay compatible.
export const daySelectHandler = (dateString: string, component: DaySelectableComponent): void => {
  // Extract month and date from the date string (YYYY-MM-DD format)
  const month = Number(dateString.substring(5, 7));
  const date = Number(dateString.substring(8, 11));
  const formattedDateStr = `${date} ${MONTH_NAMES[month]}`;

  if (dayjs(dateString).isBefore(dayjs(component.state.earliestDateAllowed))) {
    component.setState({
      dateStr: formattedDateStr,
      isDisabled: true,
      selectedDate: dateString,
      selectedTimeSlot: null,
      timeSlots: [],
      timeSlotsLoading: false,
    });

    return;
  }

  // Update component state with selected date and reset time slot related state
  component.setState({
    dateStr: formattedDateStr,
    isDisabled: true,
    selectedDate: dateString,
    selectedTimeSlot: null,
    timeSlots: null,
    timeSlotsLoading: true,
  });

  // Fetch available time slots for the selected date
  component
    .getAvailableSchedules(dateString, component.state.providerId)
    .then((cleanResponse) => {
      const timeSlots = cleanResponse.time_slots;

      // Update component state with fetched time slots
      component.setState({
        timeSlots: timeSlots,
        timeSlotsLoading: false,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
